import Marquee from "react-fast-marquee";
import { TrendingUp, TrendingDown } from "lucide-react";

const tickerItems = [
  { label: "FUNDED TODAY", value: "$4.2M", trend: "up" },
  { label: "APPROVALS", value: "127", trend: "up" },
  { label: "AVG TIME TO FUND", value: "18.4 HRS", trend: "down" },
  { label: "ACTIVE OFFERS", value: "$28.7M", trend: "up" },
  { label: "SBA FAST-TRACK", value: "LIVE", trend: "up" },
  { label: "PRIME +", value: "8.5%", trend: "up" },
  { label: "MCA FACTOR", value: "1.18x", trend: "down" },
  { label: "RENEWALS", value: "94%", trend: "up" },
  { label: "DEALS CLOSED Q4", value: "$192M", trend: "up" },
];

export default function Ticker() {
  return (
    <div
      className="fixed top-20 left-0 right-0 z-40 bg-black/80 backdrop-blur-md border-y border-white/5 py-2 overflow-hidden"
      data-testid="ticker-section"
    >
      <Marquee speed={45} gradient={false} pauseOnHover>
        {[...tickerItems, ...tickerItems].map((item, i) => (
          <div key={i} className="flex items-center gap-3 px-8 font-mono text-xs">
            <span className="text-zinc-500 tracking-widest">{item.label}</span>
            <span className="text-white font-bold">{item.value}</span>
            {item.trend === "up" ? (
              <TrendingUp className="w-3 h-3 text-[#00FFA3]" />
            ) : (
              <TrendingDown className="w-3 h-3 text-[#0052FF]" />
            )}
            <span className="text-zinc-700 mx-2">•</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
